import Polyglot from 'node-polyglot';
import { fetchI18nList } from '../service/i18n';
export default async function (baseURL, version, lang) {
    const list = await fetchI18nList(baseURL, version, lang);
    return new Polyglot({ phrases: list });
}
